import React, {
  useCallback,
  useState,
  useRef,
  useEffect,
  useContext,
} from "react";
import style from "../../style/EditBodyInput.module.scss";
import { FormControl } from "@mui/material";
import { MenuItem } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";

import { FormLabel } from "@mui/material";
import { Radio } from "@mui/material";
import { RadioGroup } from "@mui/material";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Upload from "../Upload";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import "video-react/dist/video-react.css";
import { angiemphraxisList } from "../../Data/angiemphraxisList";
import { ticiScoreList } from "../../Data/ticiScoreList";
import DOMPurify from "dompurify";
import { useMutation, useQuery, useQueryClient } from "react-query";
import PdfUpload from "../PdfUpload";
import { Link } from "react-router-dom";
import liff from "@line/liff";
import LoadingModal from "../Modal/LoadingModal";

//REACT LightGallery
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "../../style/Other.css";
import lgZoom from "lightgallery/plugins/zoom";
import apiClient from "../../libraries/ApiClient";
import { ModelContext } from "../../contexts/ModelContext";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "transparent",
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-disabled": {
        border: "none",
      },
      "&.Mui-error": {
        borderColor: "#EB4D3D",
      },
    },
  })
);

const modules = {
  toolbar: [["bold", "italic", "underline", "strike"], [{ list: "bullet" }]],
};

function EditBodyInput({
  inputData,
  setSendBasicData,
  setSendOperativeData,
  setSendMediaData,
  setSendPreoperativeMediaData,
  setSendPostoperativeMediaData,
  setSendPdfData,
  caseStatusCode,
  patientStatusCode,
}) {
  const [token, setToken] = useState("");
  const apiUrl = import.meta.env.VITE_API_ROOT_URL;
  const queryClient = useQueryClient();
  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    const params = new URLSearchParams(location.search);
    setRowId(params.get("rowId"));
  }, []);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [openView, setOpenView] = useState(0);
  const [identityError, setIdentitlyError] = useState(false);

  const { setChangeData } = useContext(ModelContext);

  const openImageViewer = useCallback((index, i) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
    setOpenView(i);
  }, []);

  const openImageViewer2 = useCallback((pUrl, pRowId) => {
    if (liff.isInClient()) {
      liff.openWindow({
        url: pUrl,
        external: true,
      });
    } else {
      window.open(pUrl);
    }
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const [rowId, setRowId] = useState("");
  const [hospital, setHospital] = useState("");
  const [identity, setIdentity] = useState("");
  const [name, setName] = useState("");
  const [nameCheckBox, setNameCheckBox] = useState(false);
  const [date, setDate] = useState(null);
  const [gender, setGender] = useState(0);
  const [pastHistory, setPastHistory] = useState("");
  const [chiefComplaint, setChiefComplaint] = useState("");
  const [erTriageTime, setErTriageTime] = useState(null);
  const [onsetTime, setOnsetTime] = useState(null);
  const [PermorbidMRS, setPermorbidMRS] = useState("");
  const [nihss, setNihss] = useState("");
  const [renalFunction, setRenalFunction] = useState("");
  const [message, setMessage] = useState("");
  const [rtpa, setRtpa] = useState(0);
  const [hitTime, setHitTime] = useState(null);
  const [dot, setDot] = useState("");
  const [screen, setScreen] = useState(0);
  const [weight, setWeight] = useState("");
  const [imageOrVideo, setImageOrVideo] = useState(null);
  const [angiemphraxis, setAngiemphraxis] = useState([]);
  const [ticiScore, setTiciScore] = useState(0);
  const [lsla, setLsla] = useState(null);
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [preoperativeMessage, setPreoperativeMessage] = useState("");
  const [postoperativeMessage, setPostoperativeMessage] = useState("");
  const [preoperativeImage, setPreoperativeImage] = useState([]);
  const [postoperativeImage, setPostoperativeImage] = useState([]);
  const [pdf, setPdf] = useState([]);
  console.log(inputData);
  //console.log(patientStatusCode);
  // console.log(postoperativeImage);
  // console.log(message);
  //console.log(angiemphraxis);

  useEffect(() => {
    setHospital(inputData?.OrgCode);
    setIdentity(inputData?.IdNo);
    setName(inputData?.Name);
    setNameCheckBox(!inputData?.Name);
    setDate(inputData?.BirthDate === null ? null : dayjs(inputData?.BirthDate));
    setGender(inputData?.Sex === undefined ? null : inputData?.Sex);
    setPastHistory(inputData?.PastHistory);
    setChiefComplaint(inputData?.ChiefComplaint);
    setOnsetTime(
      inputData?.OnsetTime === null ? null : dayjs(inputData?.OnsetTime)
    );
    setErTriageTime(
      inputData?.ErTriageDateTime === null
        ? null
        : dayjs(inputData?.ErTriageDateTime)
    );
    setPermorbidMRS(
      inputData?.PremorbidMrs === null ? null : inputData?.PremorbidMrs
    );
    setNihss(inputData?.Nihss);
    setRenalFunction(inputData?.RenalFunction);
    setRtpa(inputData?.IsRtpa === null ? null : inputData?.IsRtpa ? 1 : 0);
    setHitTime(
      inputData?.InjectDateTime === null
        ? null
        : dayjs(inputData?.InjectDateTime)
    );
    setDot(inputData?.InjectDose);
    setScreen(inputData?.IsCovid19 === undefined ? null : inputData?.IsCovid19);
    setWeight(inputData?.Weight);
    setLsla(
      inputData?.PostoperativeParameters === null
        ? null
        : inputData?.PostoperativeParameters?.IsIa
    );
    setReason(
      inputData?.PostoperativeParameters === null
        ? 0
        : inputData?.PostoperativeParameters?.ReasonCode
    );
    setOtherReason(inputData?.PostoperativeParameters?.Reason);
    setTiciScore(
      inputData?.PostoperativeParameters === null
        ? 0
        : inputData?.PostoperativeParameters?.TiciScore
    );
    setPostoperativeMessage(
      inputData?.PostoperativeParameters === null
        ? ""
        : inputData?.PostoperativeParameters?.PostoperativeContent
    );
    setPreoperativeMessage(
      inputData?.PostoperativeParameters === null
        ? ""
        : inputData?.PostoperativeParameters?.PreoperativeContent
    );
    setAngiemphraxis(
      inputData?.PostoperativeParameters?.AngiemphraxisList === null ||
        inputData?.PostoperativeParameters === null
        ? []
        : inputData?.PostoperativeParameters?.AngiemphraxisList
    );
  }, [inputData]);
  //console.log(angiemphraxis);

  const [chiefComplaintWordCount, setChiefComplaintWordCount] = useState(0);
  const [pastHistoryWordCount, setPastHistoryWordCount] = useState(0);
  const [messageWordCount, setMessageWordCount] = useState(0);

  const [selfIdentities, setSelfIdentities] = useState([]);
  //console.log(!selfIdentities?.includes("tbc_doctor"));

  const editorRef = useRef(null);
  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
  }, []);
  // console.log(angiemphraxis);
  //console.log(date);

  const sendBasicData = {
    isUnKnown: nameCheckBox,
    Name: name,
    BirthDate: date === null ? null : dayjs(date).format("yyyy/MM/dd HH:mm:ss"),
    Sex: +gender,
    IdNo: identity,
    PastHistory: pastHistory,
    ChiefComplaint: chiefComplaint,
    ErTriageDateTime:
      erTriageTime === null
        ? null
        : dayjs(erTriageTime).format("yyyy/MM/dd HH:mm:ss"),
    OnsetTime:
      onsetTime === null
        ? null
        : dayjs(onsetTime).format("yyyy/MM/dd HH:mm:ss"),
    PremorbidMrs: PermorbidMRS === null ? null : +PermorbidMRS,
    RenalFunction:
      +renalFunction === 0 || renalFunction === "" ? null : +renalFunction,
    Nihss: +nihss === 0 || nihss === "" ? null : +nihss,
    IsRtpa: rtpa === null ? null : +rtpa ? true : false,
    InjectDateTime:
      hitTime === null ? null : dayjs(hitTime).format("yyyy/MM/dd HH:mm:ss"),
    InjectDose: +dot === 0 ? null : +dot,
    IsCovid19: +screen,
    RowId: rowId,
    Content: message === "<p><br></p>" ? "" : message,
    Weight: +weight === 0 || weight === "" ? null : +weight,
    HasImageOrVideo: imageOrVideo?.length > 0 ? true : false,
  };
  //console.log(sendBasicData);
  // console.log(hitTime);
  // console.log(onsetTime);
  // console.log(sendBasicData);

  const sendOperative = {
    ReferralRowId: rowId,
    IsIa: lsla === null ? null : lsla,
    ReasonCode: reason,
    Reason: reason === 6 ? otherReason : null,
    Angiemphraxis: angiemphraxis,
    PreoperativeContent:
      preoperativeMessage === "<p><br></p>" ? "" : preoperativeMessage,
    PostoperativeContent:
      postoperativeMessage === "<p><br></p>" ? "" : postoperativeMessage,
    PostoperativeRowId: inputData?.PostoperativeParameters?.RowId,
  };

  useEffect(() => {
    setSendBasicData(sendBasicData);
    setSendMediaData(imageOrVideo);
    setSendOperativeData(sendOperative);
    setSendPreoperativeMediaData(preoperativeImage);
    setSendPostoperativeMediaData(postoperativeImage);
    setSendPdfData(pdf);
  }, [
    rowId,
    nameCheckBox,
    name,
    date,
    gender,
    identity,
    pastHistory,
    chiefComplaint,
    erTriageTime,
    onsetTime,
    PermorbidMRS,
    renalFunction,
    nihss,
    rtpa,
    hitTime,
    dot,
    screen,
    message,
    weight,
    imageOrVideo,
    lsla,
    reason,
    otherReason,
    ticiScore,
    angiemphraxis,
    preoperativeMessage,
    postoperativeMessage,
    preoperativeImage,
    postoperativeImage,
    pdf,
  ]);

  const handleHospitalChange = (e) => {
    setHospital(e.target.value);
    setChangeData(true);
  };
  const handleIdentityChange = (e) => {
    setIdentity(e.target.value);
    setChangeData(true);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
    setChangeData(true);
  };
  const handleChange = (e) => {
    setNameCheckBox(e.target.checked);
    setChangeData(true);
  };

  const handleDataChange = (newValue) => {
    setDate(newValue);
    setChangeData(true);
  };

  const handleGenderChange = (e) => {
    setGender(e.target.value);
    setChangeData(true);
  };

  const handlePastHistory = (e) => {
    const inputValue = e.target.value;
    setChangeData(true);

    let chineseCount = 0;
    let englishCount = 0;
    const characters = inputValue.split("");

    characters.forEach((char) => {
      if (char.trim().match(/[\u4e00-\u9fa5]+|[^\s\u4e00-\u9fa5]+/g)) {
        chineseCount++;
      } else {
        const englishRegex = /^[A-Za-z]+$/;
        if (englishRegex.test(char)) {
          englishCount++;
        }
      }
    });

    if (chineseCount + englishCount <= 600) {
      setPastHistory(inputValue);
      setPastHistoryWordCount(chineseCount + englishCount);
    }
  };

  const handleChiefComplaint = (e) => {
    const inputValue = e.target.value;
    setChangeData(true);

    let chineseCount = 0;
    let englishCount = 0;
    const characters = inputValue.split("");

    characters.forEach((char) => {
      if (char.trim().match(/[\u4e00-\u9fa5]+|[^\s\u4e00-\u9fa5]+/g)) {
        chineseCount++;
      } else {
        const englishRegex = /^[A-Za-z]+$/;
        if (englishRegex.test(char)) {
          englishCount++;
        }
      }
    });

    if (chineseCount + englishCount <= 600) {
      setChiefComplaint(inputValue);
      setChiefComplaintWordCount(chineseCount + englishCount);
    }
  };
  const handleErTriageDataTimeChange = (newValue) => {
    setErTriageTime(newValue);
    setChangeData(true);
  };
  const handleDataTimeChange = (newValue) => {
    // console.log(newValue);
    setOnsetTime(newValue);
    setChangeData(true);
  };
  // console.log(onsetTime);

  const handlePermorbidMRSChange = (e) => {
    setPermorbidMRS(e.target.value);
    setChangeData(true);
  };
  const handleNihssChange = (e) => {
    const inputValue = e.target.value;
    setChangeData(true);
    if (inputValue === "") {
      setNihss("");
    } else if (
      isNaN(inputValue) ||
      parseFloat(inputValue) !== parseInt(inputValue, 10)
    ) {
      alert("NIHSS請輸入整數");
      setNihss("");
    } else if (inputValue >= 42) {
      setNihss(42);
    } else if (inputValue <= 0) {
      setNihss("");
    } else {
      const removeDot = inputValue.replace(".", "");
      setNihss(removeDot);
    }
  };
  const handleKeyDown = (event) => {
    let mobile = "";
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      mobile = "ios";
    } else if (/(Android)/i.test(navigator.userAgent)) {
      mobile = "android";
    } else {
      mobile = "desktop";
    }

    if (mobile === "ios" || mobile === "desktop") {
      if (event.code === "Period" || event.code === "NumpadDecimal") {
        alert("請輸入整數");
      }
    } else if (mobile === "android") {
      if (event.key === "Unidentified") {
        alert("請輸入整數");
      }
    }
  };
  const handleRenalFunctionChange = (e) => {
    setChangeData(true);
    if (
      /^(?!^\.)(?!0\d)\d*(\.\d{0,2})?$/.test(e.target.value) &&
      e.target.value >= 0 &&
      e.target.value <= 99.99
    ) {
      setRenalFunction(e.target.value);
    } else if (e.target.value <= 0) {
      setRenalFunction("");
    }
  };
  const handleRtpaChange = (e) => {
    setRtpa(e.target.value);
    if (e.target.value === "0") {
      setHitTime(null);
      setDot(null);
    }
  };
  const handleHitTimeChange = (newValue) => {
    setHitTime(newValue);
    setChangeData(true);
  };
  const handleDotChange = (e) => {
    const inputValue = e.target.value;
    setChangeData(true);
    if (inputValue === "") {
      setDot("");
    } else if (
      isNaN(inputValue) ||
      parseFloat(inputValue) !== parseInt(inputValue, 10)
    ) {
      alert("總劑量請輸入整數");
      setDot("");
    } else if (inputValue >= 90) {
      setDot(90);
    } else if (inputValue <= 0) {
      setDot("");
    } else {
      const removeDot = inputValue.replace(".", "");
      setDot(removeDot);
    }
  };
  const handleScreenChange = (e) => {
    setChangeData(true);
    setScreen(e.target.value);
  };
  const handleWeightChange = (e) => {
    setChangeData(true);
    const inputValue = e.target.value;
    if (inputValue === "") {
      setWeight("");
    } else if (
      isNaN(inputValue) ||
      parseFloat(inputValue) !== parseInt(inputValue, 10)
    ) {
      alert("體重請輸入整數");
      setWeight("");
    } else if (inputValue >= 150) {
      setWeight(150);
    } else if (inputValue <= 0) {
      setWeight("");
    } else {
      const removeDot = inputValue.replace(".", "");
      setWeight(removeDot);
    }
  };

  const handleMessageChange = (content, delta, source, editor) => {
    setChangeData(true);
    const textValue = editorRef.current?.value || "";
    // console.log(content);
    let chineseCount = 0;
    let englishCount = 0;
    const characters = textValue.split("");

    characters.forEach((char) => {
      if (char.trim().match(/[\u4e00-\u9fa5]+|[^\s\u4e00-\u9fa5]+/g)) {
        chineseCount++;
      } else {
        const englishRegex = /^[A-Za-z]+$/;
        if (englishRegex.test(char)) {
          englishCount++;
        }
      }
    });

    if (chineseCount + englishCount <= 600) {
      setMessage(content);
      setMessageWordCount(chineseCount + englishCount);
    }

    if (messageWordCount > 600) {
      const maxAllowedWords = textValue.split(/\s+/, 600).join(" ");
      editorRef.current?.setMessage(maxAllowedWords);
      setMessage(maxAllowedWords);
      setMessageWordCount(600);
    }
  };

  const handlePostoperativeMessage = (content) => {
    setChangeData(true);
    setPostoperativeMessage(content);
  };

  const handlePreoperativeMessage = (content) => {
    setChangeData(true);
    setPreoperativeMessage(content);
  };

  const handleCheckBoxChange = (e) => {
    //console.log(123);
    setChangeData(true);
    if (angiemphraxis?.some((v) => v.Name === `${e.target.value}`)) {
      const newAngiemphraxis = angiemphraxis.filter((v, i) => {
        const { Name } = v;
        return Name !== e.target.value;
      });
      setAngiemphraxis(newAngiemphraxis);
    } else {
      const newAngiemphraxis = [
        ...angiemphraxis,
        { Name: `${e.target.value}`, List: [{ Location: 0, TiciScore: 0 }] },
      ];

      setAngiemphraxis(newAngiemphraxis);
    }
  };

  const handleRedioChange = (e, location, name) => {
    // const newAngiemphraxis = angiemphraxis.map((v, i) => {
    //   if (v.Name === name) {
    //     return { ...v, Location: +e.target.value };
    //   }
    //   return { ...v };
    // });
    // setAngiemphraxis(newAngiemphraxis);
    //console.log(name);
    setChangeData(true);
    let newAngiemphraxis = angiemphraxis.filter((v, i) => {
      const { Name } = v;
      return Name === name;
    });
    //console.log(newAngiemphraxis);
    let oldAngiemphraxis = angiemphraxis.filter((v, i) => {
      const { Name } = v;
      return Name !== name;
    });

    if (
      newAngiemphraxis[0]?.List?.some((v) => v.Location === +e.target.value)
    ) {
      // console.log("取消位置");
      let a = newAngiemphraxis.map((v, i) => {
        const { List } = v;
        const d = List?.filter((v, i) => {
          return v.Location !== +location;
        });
        return { ...v, List: d };
      });
      setAngiemphraxis([...oldAngiemphraxis, ...a]);
    } else {
      //新增位置
      if (
        newAngiemphraxis[0]?.List?.some((v) => v.Location === 0) ||
        newAngiemphraxis[0]?.List?.length === 0
      ) {
        newAngiemphraxis = [
          { Name: name, List: [{ Location: +e.target.value, TiciScore: 0 }] },
        ];
        setAngiemphraxis([...oldAngiemphraxis, ...newAngiemphraxis]);
      } else if (newAngiemphraxis[0]?.List?.some((v) => v.Location !== 0)) {
        let [{ List }] = newAngiemphraxis;
        List.push({ Location: +e.target.value, TiciScore: 0 });

        setAngiemphraxis([...oldAngiemphraxis, ...newAngiemphraxis]);
      }
    }
  };

  const handleRedioTiciScoreChange = (e, location, name) => {
    setChangeData(true);
    //設定取栓程度
    let newAngiemphraxis = angiemphraxis.filter((v, i) => {
      const { Name } = v;
      return Name === name;
    });

    let oldAngiemphraxis = angiemphraxis.filter((v, i) => {
      const { Name } = v;
      return Name !== name;
    });
    // console.log(newAngiemphraxis);
    if (name === "BA") {
      let a = newAngiemphraxis.map((v, i) => {
        const { List } = v;
        //console.log(List);
        //console.log(location);
        let c = List.map((v, i) => {
          return { ...v, TiciScore: +e.target.value };
        });
        return { ...v, List: [...c] };
      });

      setAngiemphraxis([...oldAngiemphraxis, ...a]);
    } else {
      let a = newAngiemphraxis.map((v, i) => {
        const { List } = v;
        //console.log(List);
        //console.log(location);
        const b = List?.filter((v, i) => {
          return v.Location === +location;
        });
        const d = List?.filter((v, i) => {
          return v.Location !== +location;
        });
        let c = b.map((v, i) => {
          return { ...v, TiciScore: +e.target.value };
        });
        return { ...v, List: [...d, ...c] };
      });

      setAngiemphraxis([...oldAngiemphraxis, ...a]);
    }
  };

  //console.log(angiemphraxis);

  const hanldeLslaChange = (e) => {
    setChangeData(true);
    if (e.target.value === "true") {
      setReason(0);
      setOtherReason("");
      setLsla(true);
    } else {
      setLsla(false);
    }
  };
  const handleReasonChange = (e) => {
    setChangeData(true);
    setReason(e.target.value);
  };
  const handleOtherReasonChange = (e) => {
    setChangeData(true);
    setOtherReason(e.target.value);
  };

  const getIAReason = async ({ queryKey }) => {
    const [_, token] = queryKey;
    const data = {};
    const res = await apiClient.postAes(
      "api/referral/GetIAReason/Security",
      data
    );
    return res?.data?.Data;
  };

  const identityRegex = /^[A-Z|a-z]{1}[1-2]{1}[0-9]{8}$/;
  //onBlur
  const handleIdentityBlur = (e) => {
    const input = e.target.value;
    // 20251201 移除檢核
    // setIdentitlyError(!identityRegex.test(input));
  };

  const { data: ReasonData, isLoading } = useQuery(
    ["getIAReason", token],
    getIAReason,
    {
      enabled: !lsla && !!token,
      refetchOnWindowFocus: false,
    }
  );
  //console.log(ReasonData);

  //Gallery
  const onInit = () => {
    // console.log("lightGallery has been initialized");
  };
  let block = (function isisBlock() {
    //console.log(caseStatusCode,patientStatusCode);
    if (
      // console.log(patientStatusCode)
      patientStatusCode !== 6 &&
      (caseStatusCode === 8 ||
        caseStatusCode === 9 ||
        caseStatusCode === 10 ||
        caseStatusCode === 12)
    ) {
      return true;
    }
    return false;
  })(caseStatusCode, patientStatusCode);
  //console.log(block);
  // console.log(a);
  const sendCheckData = async ({ rowId, token }) => {
    const data = {
      Data: {
        RowId: rowId,
      },
    };

    const res = await apiClient.postAes(
      "api/referral/RemovePostoperativeImage/Security",
      data
    );
    //console.log(res);
    // return res.data;
  };

  const { mutate: mutateDelPic } = useMutation(sendCheckData, {
    onSuccess: () => {
      queryClient.invalidateQueries("getReferralDetail");
    },
  });
  //console.log(lsla);

  return (
    <div className={style.container}>
      <LoadingModal isOpen={isLoading} />
      <div className={style.top_container}>
        <div className={style.title} id="one">
          轉介個案資訊
        </div>
        <div className={style.fist_line}>
          <div className={style.hospital_box}>
            <CssTextField
              label="轉出醫院"
              select
              variant="filled"
              onChange={handleHospitalChange}
              value={hospital}
              disabled={true}
            >
              <MenuItem value={hospital} style={{ fontSize: "14px" }} disabled>
                請選擇轉出醫院
              </MenuItem>
              <MenuItem value={hospital} style={{ fontSize: "14px" }}>
                {inputData?.OrgName}
              </MenuItem>
            </CssTextField>
          </div>
          <div className={style.identity_box}>
            <CssTextField
              label="請輸入個案身分證字號"
              variant="filled"
              onChange={handleIdentityChange}
              value={identity}
              style={{ width: "100%" }}
              onBlur={handleIdentityBlur}
              error={identityError}
            />
          </div>
        </div>
        <div className={style.second_line}>
          <div className={style.name_box}>
            <CssTextField
              label="輸入個案姓名"
              variant="filled"
              onChange={handleNameChange}
              value={name}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.name_checkbox}>
            <Checkbox
              size="small"
              checked={nameCheckBox}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
              sx={{
                color: "#ccc",
                "&.Mui-checked": {
                  color: "#057aff",
                },
              }}
            />
            無法確認個案姓名
          </div>
        </div>
        <div className={style.third_line}>
          <div className={style.date_box}>
            <DesktopDatePicker
              label="輸入個案生日"
              inputFormat="yyyy/MM/dd"
              value={date}
              onChange={handleDataChange}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <CssTextField {...params} variant="filled" />
              )}
            />
          </div>
          <div className={style.gender_box}>
            <FormControl fullWidth>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                個案性別
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleGenderChange}
                value={gender}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="男生"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="女生"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <div className={style.third_line}>
          <div className={style.onsetTime_box}>
            <DateTimePicker
              label="急診檢傷時間"
              inputFormat="yyyy/MM/dd HH:mm"
              value={erTriageTime}
              onChange={handleErTriageDataTimeChange}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <CssTextField {...params} variant="filled" />
              )}
            />
          </div>
        </div>
        <div className={style.four_line}>
          <div className={style.past_history}>
            <CssTextField
              label="Past History"
              multiline
              rows={5}
              variant="filled"
              style={{ width: "100%" }}
              value={pastHistory}
              onChange={handlePastHistory}
              helperText={`${pastHistoryWordCount}/600 words`}
            />
          </div>
        </div>
        <div className={style.five_line}>
          <div className={style.chief_complaint}>
            <CssTextField
              label="Chief Complaint"
              multiline
              rows={5}
              variant="filled"
              style={{ width: "100%" }}
              value={chiefComplaint}
              onChange={handleChiefComplaint}
              helperText={`${chiefComplaintWordCount}/600 words`}
            />
          </div>
        </div>
        <div className={style.six_line}>
          <div className={style.onsetTime_box}>
            <DateTimePicker
              label="onset time"
              inputFormat="yyyy/MM/dd HH:mm"
              value={onsetTime}
              onChange={handleDataTimeChange}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <CssTextField {...params} variant="filled" />
              )}
            />
          </div>
          <div className={style.premorbidMRS_box}>
            <CssTextField
              label="Premorbid MRS"
              select
              variant="filled"
              onChange={handlePermorbidMRSChange}
              value={PermorbidMRS}
              style={{ width: "100%" }}
            >
              <MenuItem
                value={PermorbidMRS}
                style={{ fontSize: "14px" }}
                disabled
              >
                請選擇0-5
              </MenuItem>
              {Array(6)
                .fill(6)
                .map((v, i) => {
                  return (
                    <MenuItem value={i} style={{ fontSize: "14px" }} key={i}>
                      {i}
                    </MenuItem>
                  );
                })}
            </CssTextField>
          </div>
        </div>
        <div className={style.seven_line}>
          <div className={style.NIHSS_box}>
            <CssTextField
              label="NIHSS"
              onChange={handleNihssChange}
              onKeyDown={handleKeyDown}
              value={nihss}
              placeholder="請輸入(1-42)"
              variant="filled"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: 42,
                  inputMode: "numeric",
                },
              }}
            />
          </div>
          <div className={style.RenalFumction_box}>
            <CssTextField
              label="Renal function(Cr.data)"
              onChange={handleRenalFunctionChange}
              value={renalFunction}
              placeholder="最大可輸入99.99"
              variant="filled"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: 100,
                  inputMode: "decimal",
                },
              }}
            />
          </div>
        </div>
        <div className={style.eight_line}>
          <div className={style.rtpa_box}>
            <FormControl
              style={{
                display: "flex",
                justifyContent: "center",
              }}
              fullWidth
            >
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                rt-PA(+/-)
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleRtpaChange}
                value={rtpa}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio size="small" />}
                  label="無"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="有"
                />
              </RadioGroup>
              <div
                style={{
                  display: +rtpa ? "block" : "none",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <DateTimePicker
                  label="施打時間"
                  inputFormat="yyyy/MM/dd HH:mm"
                  value={hitTime}
                  onChange={handleHitTimeChange}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <CssTextField {...params} variant="filled" />
                  )}
                />
                <CssTextField
                  label="總劑量(mg)"
                  onChange={handleDotChange}
                  value={dot}
                  style={{ width: "100%", marginTop: "10px" }}
                  placeholder="請輸入(1-90)"
                  variant="filled"
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    inputProps: {
                      inputMode: "numeric",
                    },
                  }}
                />
              </div>
            </FormControl>
          </div>
          <div className={style.screen_box}>
            {/* <FormControl fullWidth>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                快篩結果
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleScreenChange}
                value={screen}
              >
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="陰性"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="陽性"
                />
                <FormControlLabel
                  value={3}
                  control={<Radio size="small" />}
                  label="檢驗中"
                />
              </RadioGroup>
            </FormControl> */}
            <CssTextField
              label="體重(kg)"
              onChange={handleWeightChange}
              value={weight}
              placeholder="請輸入(1-150)"
              variant="filled"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  inputMode: "numeric",
                },
              }}
              shrink
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
        {/* <div className={style.nine_line}>
          <div className={style.RenalFumction_box}>
           
          </div>
        </div> */}
      </div>
      <div className={style.bottom_container} id="two">
        <div className={style.title}>病情留言板</div>
        <div className={style.upload_box}>
          <Upload setImageOrVideo={setImageOrVideo} />
        </div>
        <ReactQuill
          theme="snow"
          value={message}
          onChange={handleMessageChange}
          className={style.message_box}
          modules={modules}
        />
        <div className={style.timeline_box}>
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
              },
            }}
          >
            {inputData?.MessageParameters?.map((v, i) => {
              return (
                <TimelineItem key={i}>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: "12px", px: 2 }}>
                    <Typography style={{ fontSize: "10px" }}>
                      {v.MessageUser}
                    </Typography>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(v.Content),
                      }}
                      style={{ fontSize: "10px" }}
                    ></div>
                    <Typography style={{ fontSize: "10px" }}>
                      {dayjs(v.MessageDateTime).format("YYYY/MM/DD HH:mm")}
                    </Typography>
                    <div style={{ width: "100%" }}>
                      {v.ImageUrls?.map(({ Url, RowId, FileRowId }) => ({
                        src: `${apiUrl}${Url}`,
                        rowId: RowId,
                        fileRowId: FileRowId,
                      }))?.map(({ src, rowId, fileRowId }, index) => (
                        <LightGallery
                          onInit={onInit}
                          speed={500}
                          plugins={[lgZoom]}
                          elementClassNames="lightgallery-body"
                        >
                          <div
                            href={src}
                            style={{
                              height: "100px",
                              width: "150px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              alt=""
                              src={src}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                padding: "4px",
                              }}
                            />
                          </div>
                        </LightGallery>
                      ))}
                    </div>
                    {v.VideoUrls?.map((v) => {
                      return `${apiUrl}${v}`;
                    })?.map((src, index) => (
                      <video controls className={style.video}>
                        <source src={src} type="video/mp4" />
                      </video>
                    ))}
                  </TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        </div>
      </div>

      <div
        className={style.bottom_container}
        id="three"
        style={{ display: block ? `block` : `none` }}
      >
        <div className={style.title}>術後病情回覆</div>
        <div className={style.switch_box}>
          {/* <Stack direction="row" spacing={1} alignItems="center">
                <p>無取栓</p>
                <Switch
                  checked={lsla}
                  onChange={hanldeLslaChange}
                  inputProps={{ "aria-label": "controlled" }}
                  disabled={
                    !selfIdentities?.includes("tbc_doctor") &&
                    !selfIdentities?.includes("nurse")
                  }
                />
                <p>有取栓</p> */}
          <div className={style.switch_box_box}>
            <FormControl
              style={{
                display: "flex",
                justifyContent: "center",
              }}
              fullWidth
            >
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                取栓情況
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={hanldeLslaChange}
                value={lsla}
              >
                <FormControlLabel
                  value={false}
                  control={<Radio size="small" />}
                  label="無取栓"
                  disabled={
                    !selfIdentities?.includes("tbc_doctor") &&
                    !selfIdentities?.includes("nurse")
                  }
                />
                <FormControlLabel
                  value={true}
                  control={<Radio size="small" />}
                  label="有取栓"
                  disabled={
                    !selfIdentities?.includes("tbc_doctor") &&
                    !selfIdentities?.includes("nurse")
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>

          {/* </Stack> */}
        </div>
        <div className={style.reason_box}>
          <CssTextField
            label="未取栓原因"
            select
            variant="filled"
            onChange={handleReasonChange}
            value={reason}
            style={{ display: lsla === null || lsla ? "none" : "block" }}
            disabled={
              !selfIdentities?.includes("tbc_doctor") &&
              !selfIdentities?.includes("nurse")
            }
          >
            <MenuItem value={hospital} style={{ fontSize: "10px" }} disabled>
              請選擇未取栓原因
            </MenuItem>
            {ReasonData?.map((v, i) => {
              return (
                <MenuItem value={v.Code} style={{ fontSize: "10px" }}>
                  {v.Name}
                </MenuItem>
              );
            })}
          </CssTextField>
        </div>
        <div style={{ display: reason === +6 ? "block" : "none" }}>
          <CssTextField
            label="輸入不取栓原因"
            variant="filled"
            onChange={handleOtherReasonChange}
            value={otherReason}
            style={{ width: "100%" }}
          />
        </div>
        <div
          className={style.little_title}
          style={{ display: lsla ? "flex" : "none" }}
        >
          <div className={style.left_box}></div>
          阻塞位置與打通程度
        </div>
        <div
          className={style.angiemphraxisList_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          {" "}
          <div
            className={style.angiemphraxisList_content}
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {angiemphraxisList?.map((itemOne, indexOne) => {
              //console.log(itemOne);
              return (
                <div className={style.angiemphraxisList_Box} key={indexOne}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={itemOne.Value}
                        checked={angiemphraxis?.some(
                          (v) => v.Name === itemOne.Value
                        )}
                        onChange={(e) => {
                          handleCheckBoxChange(e);
                        }}
                        sx={{
                          input: {
                            position: "relative",
                          },
                        }}
                        disabled={
                          !selfIdentities?.includes("tbc_doctor") &&
                          !selfIdentities?.includes("nurse")
                        }
                      />
                    }
                    label={<p style={{ fontSize: "12px" }}>{itemOne.Label}</p>}
                  />
                  <div
                    style={{
                      display: angiemphraxis?.some(
                        (v) => v.Name === itemOne?.Value
                      )
                        ? "flex"
                        : "none",
                    }}
                  >
                    <div
                      style={{
                        padding: "0px 0px 0px 48px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {itemOne?.Radio?.map((itemTwo, indexTwo) => {
                        return (
                          <>
                            {itemOne.Value === "BA" ? (
                              <RadioGroup
                                style={{
                                  display: angiemphraxis?.filter((v, i) => {
                                    return v.Name === itemOne?.Value;
                                  })
                                    ? "flex"
                                    : "none",
                                }}
                                value={ticiScore}
                              >
                                <div>
                                  {ticiScoreList?.map((itemThree, i) => {
                                    return (
                                      <FormControlLabel
                                        control={
                                          <Radio
                                            size="small"
                                            key={i}
                                            value={itemThree.Value}
                                            disabled={
                                              !selfIdentities?.includes(
                                                "tbc_doctor"
                                              ) &&
                                              !selfIdentities?.includes("nurse")
                                            }
                                            checked={angiemphraxis
                                              ?.filter((v, i) => {
                                                return (
                                                  v.Name === itemOne?.Value
                                                );
                                              })[0]
                                              ?.List?.some(
                                                (v, i) =>
                                                  v.TiciScore ===
                                                  +itemThree.Value
                                              )}
                                            onChange={(e) => {
                                              handleRedioTiciScoreChange(
                                                e,
                                                itemTwo.Value,
                                                itemOne.Value
                                              );
                                            }}
                                          />
                                        }
                                        label={
                                          <p style={{ fontSize: "12px" }}>
                                            {itemThree.Label}
                                          </p>
                                        }
                                      />
                                    );
                                  })}
                                </div>
                              </RadioGroup>
                            ) : (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      value={itemTwo.Value}
                                      checked={
                                        angiemphraxis
                                          ?.filter((v, i) => {
                                            return v.Name === itemOne.Value;
                                          })[0]
                                          ?.List?.some(
                                            (v, i) =>
                                              v.Location === +itemTwo.Value
                                          )
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        handleRedioChange(
                                          e,
                                          itemTwo.Value,
                                          itemOne.Value
                                        );
                                      }}
                                      key={indexTwo}
                                      disabled={
                                        !selfIdentities?.includes(
                                          "tbc_doctor"
                                        ) && !selfIdentities?.includes("nurse")
                                      }
                                    />
                                  }
                                  label={
                                    <p style={{ fontSize: "12px" }}>
                                      {itemTwo.Label}
                                    </p>
                                  }
                                />{" "}
                                <RadioGroup
                                  style={{
                                    display: angiemphraxis
                                      ?.filter((v, i) => {
                                        return v.Name === itemOne?.Value;
                                      })[0]
                                      ?.List?.some(
                                        (v, i) => v.Location === +itemTwo.Value
                                      )
                                      ? "flex"
                                      : "none",
                                  }}
                                  value={ticiScore}
                                >
                                  <div>
                                    {ticiScoreList?.map((itemThree, i) => {
                                      return (
                                        <FormControlLabel
                                          control={
                                            <Radio
                                              size="small"
                                              key={i}
                                              value={itemThree.Value}
                                              disabled={
                                                !selfIdentities?.includes(
                                                  "tbc_doctor"
                                                ) &&
                                                !selfIdentities?.includes(
                                                  "nurse"
                                                )
                                              }
                                              checked={angiemphraxis
                                                ?.filter((v, i) => {
                                                  return (
                                                    v.Name === itemOne?.Value
                                                  );
                                                })[0]
                                                ?.List?.some(
                                                  (v, i) =>
                                                    v.Location ===
                                                      +itemTwo.Value &&
                                                    v.TiciScore ===
                                                      +itemThree.Value
                                                )}
                                              onChange={(e) => {
                                                handleRedioTiciScoreChange(
                                                  e,
                                                  itemTwo.Value,
                                                  itemOne.Value
                                                );
                                              }}
                                            />
                                          }
                                          label={
                                            <p style={{ fontSize: "12px" }}>
                                              {itemThree.Label}
                                            </p>
                                          }
                                        />
                                      );
                                    })}
                                  </div>
                                </RadioGroup>
                              </>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div
          className={style.little_title}
          style={{ display: lsla ? "flex" : "none" }}
        >
          <div className={style.left_box}></div>
          術前和術後影像照片
        </div>
        <div
          className={style.before_image_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={style.before_image_little_title}>術前影像照片</div>
            <div className={style.before_image_right_box}></div>
          </div>
          <div className={style.before_image_content}>
            {inputData?.PostoperativeParameters?.PreoperativeImage?.map(
              ({ Url, RowId, FileRowId }) => ({
                src: `${apiUrl}${Url}`,
                rowId: RowId,
                fileRowId: FileRowId,
              })
            )?.map(({ src, rowId, fileRowId }, index) => (
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  margin: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <LightGallery
                  onInit={onInit}
                  speed={500}
                  plugins={[lgZoom]}
                  elementClassNames="lightgallery-body"
                >
                  <div
                    href={src}
                    style={{
                      height: "100px",
                      width: "150px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ccc",
                    }}
                  >
                    <img
                      alt=""
                      src={src}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        padding: "4px",
                      }}
                    />
                  </div>
                </LightGallery>
                <div
                  style={{ padding: "8px 0px", cursor: "pointer" }}
                  onClick={() => {
                    mutateDelPic({ rowId, token });
                  }}
                >
                  刪除
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className={style.upload_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <Upload
            setImageOrVideo={setPreoperativeImage}
            disabled={
              !selfIdentities?.includes("tbc_doctor") &&
              !selfIdentities?.includes("nurse")
            }
          />
        </div>
        <div
          className={style.before_message_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <div className={style.before_message_title}>
            <div className={style.before_message_little_title}>
              術前影像補充說明
            </div>
            <div className={style.before_message_right_box}></div>
          </div>

          <ReactQuill
            theme="snow"
            value={postoperativeMessage}
            onChange={handlePostoperativeMessage}
            className={style.message_box}
            modules={modules}
            readOnly={
              !selfIdentities?.includes("tbc_doctor") &&
              !selfIdentities?.includes("nurse")
            }
          />
        </div>

        <div
          className={style.little_title}
          style={{ display: lsla ? "block" : "none" }}
        ></div>
        <div
          className={style.before_image_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={style.before_image_little_title}>術後影像照片</div>
            <div className={style.before_image_right_box}></div>
          </div>
          <div className={style.before_image_content}>
            {inputData?.PostoperativeParameters?.PostoperativeImage?.map(
              ({ Url, RowId, FileRowId }) => ({
                src: `${apiUrl}${Url}`,
                rowId: RowId,
                fileRowId: FileRowId,
              })
            )?.map(({ src, rowId, fileRowId }, index) => (
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  margin: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <LightGallery
                  onInit={onInit}
                  speed={500}
                  plugins={[lgZoom]}
                  elementClassNames="lightgallery-body"
                >
                  <div
                    href={src}
                    style={{
                      height: "100px",
                      width: "150px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ccc",
                    }}
                  >
                    <img
                      alt=""
                      src={src}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        padding: "4px",
                      }}
                    />
                  </div>
                </LightGallery>
                <div
                  style={{ padding: "8px 0px", cursor: "pointer" }}
                  onClick={() => {
                    mutateDelPic({ rowId, token });
                  }}
                >
                  刪除
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className={style.upload_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <Upload
            setImageOrVideo={setPostoperativeImage}
            disabled={
              !selfIdentities?.includes("tbc_doctor") &&
              !selfIdentities?.includes("nurse")
            }
          />
        </div>
        <div
          className={style.before_message_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <div className={style.before_message_title}>
            <div className={style.before_message_little_title}>
              術後影像補充說明
            </div>
            <div className={style.before_message_right_box}></div>
          </div>
          <ReactQuill
            theme="snow"
            value={preoperativeMessage}
            onChange={handlePreoperativeMessage}
            className={style.message_box}
            modules={modules}
            readOnly={
              !selfIdentities?.includes("tbc_doctor") &&
              !selfIdentities?.includes("nurse")
            }
          />
        </div>
        <div
          className={style.ticiScoreList_box}
          style={{ display: lsla ? "block" : "none" }}
        >
          <div className={style.ticiScoreList_content}></div>
        </div>
      </div>

      <div
        className={style.bottom_container}
        id="four"
        style={{ display: block ? `block` : `none` }}
      >
        <div className={style.title}>轉診回饋單</div>
        <div
          style={{
            display: selfIdentities?.includes("case_management")
              ? "block"
              : "none",
          }}
        >
          上傳轉診回饋單
        </div>
        <div style={{ padding: "10px" }}>
          <PdfUpload
            setPdf={setPdf}
            disabled={!selfIdentities?.includes("case_management")}
          />
          <div>轉診回饋單(顯示最新存檔之檔案)</div>
          {inputData?.ReferralFeedback === null ? (
            <h1>尚無資料</h1>
          ) : (
            <Link
              to={`${apiUrl}${inputData?.ReferralFeedback}`}
              target="_blank"
            >
              點此查看轉診回饋
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default EditBodyInput;
